<template>
  <div class="bgfff">
    <div class="w1200">
      <div class="outsideTop">
        <div class="left" @click="$router.push('/goodsList?page=newFlag')">
          <a href="javascript:void(0)" class="jumpHome">
            <img src="@/assets/img/nk_logo.png" class="nk]_logo" alt="">
          </a>
          <span class="shopname">挪客商城</span>
        </div>
        <div class="right" v-if="userInfo.loginName == null ? true : false">
          <a href="/#/goodsList?page=newFlag">商城首页</a>
          <a href="/#/login">我要登录</a>
          <a href="/#/register">注册账号</a>
          <a href="/#/retrievePassword">找回密码</a>
        </div>
        <div class="useredRight" v-if="userInfo.loginName == null ? false : true">
          <el-popover placement="top-start" trigger="hover" popper-class="usernameClass" :close-delay="50" :visible-arrow="true">
            <div class="openPopover">
              <a v-on:click.stop="exit" href="javascript:void(0)">退出</a>
            </div>
            <span class="el-dropdown-link" slot="reference">
              {{userInfo.userName||userInfo.loginName}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>
          <el-popover placement="top-start" trigger="hover" popper-class="tabPopover" :close-delay="50" :visible-arrow="true">
            <div class="openPopover">
              <a href="/#/myInfomation">个人信息</a>
              <a href="/#/userCenter?tap=3">账号安全</a>
              <a href="/#/rebate" v-if="userInfo.isSeeBack=='1'">返利管理</a>
              <a href="/#/address">收货地址</a>
              <!-- <a href="/#/shopCollection">收藏店铺</a> -->
              <!-- <a href="/#/goodsCollection">关注商品</a> -->
              <a href="/#/myStripe" v-if="userInfo.isHaveWhiteNote">我的授信</a>
              <!-- <a href="/#/mySalesman">业务员</a> -->
            </div>
            <span class="el-dropdown-link" slot="reference" v-if="userInfo.userId&&userInfo.userId!=10853">
              个人中心
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>
          <el-popover placement="top-start" trigger="hover" popper-class="tabPopover" :close-delay="50" :visible-arrow="true">
            <div class="openPopover">
              <!-- <a href="/#/shoppingcart">购物车</a> -->
              <a href="/#/myOrderRight">我的订单</a>
              <a href="/#/invoicingPage" v-if="isgrayscale">申请开票</a> 
              <a href="/#/invoiceList" v-if="isgrayscale">发票管理</a>
              <a href="/#/pointsOrder">积分订单</a>
            </div>
            <span class="el-dropdown-link" slot="reference" v-if="userInfo.userId&&userInfo.userId!=10853">
              订单中心
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>
          <el-popover placement="top-start" trigger="hover" popper-class="tabPopover" :close-delay="50" :visible-arrow="true">
            <div class="openPopover">
              <a href="/#/refund">我的售后</a>
              <a href="/#/consultation">商品咨询</a>
            </div>
            <span class="el-dropdown-link" slot="reference" v-if="userInfo.userId&&userInfo.userId!=10853">
              客户服务
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>
          <el-popover placement="top" trigger="hover" :close-delay="50" popper-class="tabPopover" :visible-arrow="true">
            <div class="openPopover">
              <a href="/#/myScores">我的积分</a>
              <a href="/#/paymentCenter?tap=2">账户余额</a>
              <a href="/#/myRedPack">我的红包</a>
              <!-- <a href="/#/paymentCenter?tap=6">我的充值卡</a> -->
            </div>
            <span class="el-dropdown-link" slot="reference" v-if="userInfo.userId&&userInfo.userId!=10853">
              财产中心
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      }
    },
    computed:{
        isgrayscale(){
          return this.$store.state.grayscale
        }
    },
    methods: {
      exit() {
        setTimeout(() => {
          localStorage.clear();
          this.userInfo = {};
          this.$store.commit("getCartList", []);
          this.$router.push("/goodsList?page=newFlag");
        }, 50)
      }
    }
  }
</script>


<style scoped lang="less">
  .bgfff {
    border-bottom: 2px solid #EA0A2A;
    .w1200 {
      margin: 0 auto;
      .outsideTop {
        display: flex;
        justify-content: space-between;
        align-items: end;
        padding: 12px 16px;
        .left {
          .jumpHome {
            display: inline-block;
            box-sizing:border-box;
            img {
              height:60px;
            }
          }
          .shopname {
            display: inline-block;
            font-size: 22px;
            vertical-align:bottom;
            line-height: 20px;
            font-weight:600;
            padding-bottom:10px;
            cursor: pointer;
          }
        }
        .right {
          display: flex;
          a {
            font-size: 16px;
            position: relative;
            padding-right: 20px;
            &:not(:last-child)::after {
              content: "";
              position: absolute;
              height: 80%;
              width: 2px;
              background: #c0c4cc;
              top: 50%;
              transform: translateY(-50%);
              right: 10px;
            }
            &:last-child {
              padding-right: 0px;
            }
          }
        }
        .useredRight {
          font-size: 14px;
          .el-icon--right {
            margin-left: 0px;
            font-weight: 600px;
          }
        }
      }
    }
  }

  .el-dropdown-link {
    margin-left: 20px;
    &:hover {
      color: rgba(234, 10, 42, 1);
      cursor: pointer;
    }
  }

  .openPopover {
    max-width: 600px;
    display: flex;
    flex-wrap: wrap;
    a {
      margin-right: 12px;
      display: inline-block;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/outsideTop.vue